<mat-card *appHasRoles="['admin', 'manager', 'agent', 'compliance', 'partner', 'partner_support']" class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>SMS / E-Mail logs</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <app-customer-email-log-view [logs]="logs"></app-customer-email-log-view>


  </mat-card-content>
</mat-card>
